module.exports =
  updateSeoPageMetaHash: (seoMetaHash) ->
    {title, pageMeta} = seoMetaHash
    return unless pageMeta
    {canonical, keywords, description, noindexed, prev, next, alternates} = pageMeta

    $head = $('head')
    $head.find('title').text title
    $head.find('link[rel="canonical"]').attr 'href', canonical
    $head.find('meta[name="keywords"]').attr 'content', keywords
    $head.find('meta[name="description"]').attr 'content', description
    for alternate in alternates
      $head.find("link[hreflang='#{alternate.hreflang}']").attr 'href', alternate.href

    $robots = $head.find('meta[name="robots"]')
    if !noindexed
      $robots.remove()
    else if $robots.length < 1
      $head.append '<meta name="robots" content="noindex,nofollow">'

    $prev = $head.find('link[rel="prev"]')
    if !prev
      $prev.remove()
    else if $prev.length
      $prev.attr 'href', prev
    else
      $head.append "<link rel='prev' href='#{ prev }'>"

    $next = $head.find('link[rel="next"]')
    if !next
      $next.remove()
    else if $next.length
      $next.attr 'href', next
    else
      $head.append "<link rel='next' href='#{ next }'>"
